import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { monthlyUsage } from '../../helpers/api';

function SimpleAreaChart() {

    const data = [
        {
            name: 'Page A',
            uv: 4000,
            pv: 2400,
            amt: 2400,
        },
        {
            name: 'Page B',
            uv: 3000,
            pv: 1398,
            amt: 2210,
        },
        {
            name: 'Page C',
            uv: 2000,
            pv: 9800,
            amt: 2290,
        },
        {
            name: 'Page D',
            uv: 2780,
            pv: 3908,
            amt: 2000,
        },
        {
            name: 'Page E',
            uv: 1890,
            pv: 4800,
            amt: 2181,
        },
        {
            name: 'Page F',
            uv: 2390,
            pv: 3800,
            amt: 2500,
        },
        {
            name: 'Page G',
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ];

    // const [data, setData] = useState([])

    // const getData = async () => {
    //     try {
    //         const response = await monthlyUsage()
    //         console.log("monthlusgae", response);
    //         setData(response.message)
    //     }
    //     catch (e) {
    //         console.log(e);
    //     }
    // }

    // useEffect(() => {
    //     getData()
    // }, [])


    return (
        <div style={{ height: "300px" }}>
            <ResponsiveContainer className="SimpleArea_BarChart" width={"100%"} height="90%">
                <AreaChart
                    className='area_chart'
                    data={data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Area type="monotone" dataKey="uv" stroke="#8F43EE" fill="#8F43EE" />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    )
}

export default SimpleAreaChart
